import { Injectable, inject } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { Actions, createEffect, ofType, OnInitEffects } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

// Actions
import {
  initCommonState,
  loadPrivacyState,
  loadPrivacyStateSuccess,
  loadPrivacyStateError,
  loadTermsState,
  loadTermsStateSuccess,
  loadTermsStateError,
} from './common.actions';

// Services
import { CommonService } from '@services/common.service';

@Injectable()
export class CommonEffects implements OnInitEffects {
  private actions$ = inject(Actions);
  private store = inject(Store);
  private commonService = inject(CommonService);

  ngrxOnInitEffects(): Action {
    return initCommonState();
  }

  initCommonState$ = createEffect(() =>
    this.actions$.pipe(
      ofType(initCommonState),
      map(() => {
        this.store.dispatch(loadPrivacyState());
        return loadTermsState();
      }),
    ),
  );

  loadPrivacyData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadPrivacyState),
      switchMap(() =>
        this.commonService.getPrivacyPolicy().pipe(
          map(profileData => loadPrivacyStateSuccess({ privacy: profileData })),
          catchError(error => of(loadPrivacyStateError({ error }))),
        ),
      ),
    ),
  );

  loadTermsData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadTermsState),
      switchMap(() =>
        this.commonService.getTermsAndCondition().pipe(
          map(profileData => loadTermsStateSuccess({ terms: profileData })),
          catchError(error => of(loadTermsStateError({ error }))),
        ),
      ),
    ),
  );
}
